import { LoadingSpinnerProps } from './loading-spinner.types'
import { LoadingSpinner as LoadingSpinnerUI } from '@touche-lts/panel-ui/dist'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'

const LoadingSpinnerComponent = (props: LoadingSpinnerProps) => {
  const { show, ...rest } = props
  const {
    generalStore: { loading }
  } = useRootStore()

  return <LoadingSpinnerUI show={loading || show} {...rest} />
}

const LoadingSpinner = observer(LoadingSpinnerComponent)
export { LoadingSpinner }
